module.exports = __webpack_public_path__ + "static/media/question.cc7d3009.png";